import { c as throwApiError, i as createApiClient } from "./client-x6vJatG_.js";
//#region src/commands/auth/api.ts
async function fetchOrgs(token) {
	const { data, error, response } = await createApiClient(token).GET("/v1/auth/orgs");
	if (error) throwApiError("Failed to fetch orgs", response.status, error.detail);
	return data.organizations;
}
//#endregion
export { fetchOrgs as t };

//# sourceMappingURL=api-DUOmLi5v.js.map